import {Windows95Window} from "../Windows95Window";
import {Container, Graphics, NineSlicePlane, Sprite, Text, TextStyle, Texture} from "pixi.js";
import {tsthreeConfig} from "../../../config/tsthreeConfig";
import {HelperFunctions} from "../../../tsthree";
import {DropdownPrefab} from "../DropdownPrefab";
import {GAME_FONT} from "../../Constants/Constants";
import {buttonify} from "../../../engine/HelperFunctions/buttonify";
import {SearchbarPrefab} from "../SearchbarPrefab";
import MiniSearch from "minisearch";
import {SpecialPageTypes} from "../../Data/WebsiteContents";
import {uppercaseFirstLettersInString} from "../../../engine/HelperFunctions/uppercaseFirstLettersInString";
import { IWindowState } from "../../Types/IWindowState";

export enum DoctOSWindowType {
    Exam,
    Treatment,
    Diagnosis,
}

export const DoctOSWindowTypeToSpecialPageType = {
    [DoctOSWindowType.Exam]: SpecialPageTypes.Exams,
    [DoctOSWindowType.Diagnosis]: SpecialPageTypes.Diagnoses,
    [DoctOSWindowType.Treatment]: SpecialPageTypes.Treatments,
};

export class Win95DoctOSWindow extends Windows95Window {

    private patientDropdown: DropdownPrefab;
    private currentType: DoctOSWindowType = DoctOSWindowType.Exam;
    private selectedId: string;
    private fieldText: Text;
    private blockInput = false;
    private fieldStatusIcon: Sprite = null;
    public searchBar: SearchbarPrefab = null;

    public set hasContext(val: boolean) {
        this._hasContext = val;
        this.searchBar.acceptingInput = val;
    }

    constructor(_settings: {
        onRequest: (
            _type: DoctOSWindowType,
            _id: string,
            _patientName: string,
        ) => Promise<void>;
        onMinimise: () => void;
        onClose: () => void;
        windowStateRef: IWindowState<Win95DoctOSWindow>;
    }) {
        super({
            title: "DoctOS Connection",
            dimensions: {
                width: 300,
                height: 360,
            },
            iconKey: "doctos-icon",
            windowStateRef: _settings.windowStateRef,

            onMinimise: _settings.onMinimise,
            onClose: _settings.onClose,
        });

        const sharedTextStyle = new TextStyle({
            fill: 0x000000,
            fontFamily: GAME_FONT,
            fontSize: 11,
        });

        const doctOSLogoBg = new NineSlicePlane(
            ENGINE.getPIXIResource("inner-container-nineslice") as Texture
        );
        doctOSLogoBg.width = 292;
        doctOSLogoBg.height = 78;
        doctOSLogoBg.position.set(
            4, 4
        );
        this.contentContainer.addChild(doctOSLogoBg);

        const doctOSLogo = new Sprite(ENGINE.getPIXIResource("doctos-logo") as Texture);
        HelperFunctions.smartScale2D({
            x: 286,
            y: null
        }, doctOSLogo);
        doctOSLogo.position.set(2, 7);
        doctOSLogoBg.addChild(doctOSLogo);

        const searchBar = this.searchBar = new SearchbarPrefab({
            width: 200,
            skipButtons: true,
            onType: () => {
                fieldStatusIcon.visible = false;
                this.selectedId = "";
            },
            searchFilterFunction: (result) => result.type === DoctOSWindowTypeToSpecialPageType[this.currentType]
        });
        searchBar.updateSearch(
            (_results: { name: string, id: string }[]) => {
                if(this.blockInput) return;
                // const lgl = SearchbarPrefab.getMinisearchCache();
                // const results = lgl.search(
                //     searchBar.currentText,
                //     {
                //         fuzzy: 0.1,
                //         prefix: true,
                //         filter: (result) => result.type === DoctOSWindowTypeToSpecialPageType[this.currentType]
                //     }
                // );
                // console.log(searchBar.currentText);
                // console.log(lgl);
                // console.log(results);
                if(_results.length > 0) {
                    searchBar.currentText = _results[0].name;
                    this.selectedId = _results[0].id;
                    fieldStatusIcon.visible = true;
                    fieldStatusIcon.texture =
                        ENGINE.getPIXIResource("green-tick") as Texture;
                } else {
                    this.selectedId = "";
                    fieldStatusIcon.visible = true;
                    fieldStatusIcon.texture =
                        ENGINE.getPIXIResource("warning-icon") as Texture;
                }
            },
            () => {

            },
        );
        searchBar.position.set(
            (searchBar.width * 0.5) + 96,
            120 - 3
        );
        this.contentContainer.addChild(searchBar);

        const patientDropDownContainer = new Container();
        const patientDropDownText = new Text("Patient: ", sharedTextStyle);
        patientDropDownText.position.set(-8, 3);
        patientDropDownContainer.addChild(patientDropDownText);
        const patientDropdown = this.patientDropdown = new DropdownPrefab({
            width: 200,
            onSelect: (_selectedValue) => {

            }
        });
        patientDropdown.position.set(81, 0);
        patientDropDownContainer.addChild(patientDropdown);
        this.contentContainer.addChild(patientDropDownContainer);
        patientDropDownContainer.position.set(15, 90);

        const fieldText = this.fieldText = new Text("Examination: ", sharedTextStyle);
        fieldText.position.set(15 - 8, 120);
        this.contentContainer.addChild(fieldText);
        const fieldStatusIcon = this.fieldStatusIcon = new Sprite(
            ENGINE.getPIXIResource("warning-icon") as Texture
        );
        fieldStatusIcon.anchor.set(1, 0.5);
        fieldStatusIcon.position.set(
            -(searchBar.width * 0.5) - 2, 9
        );
        fieldStatusIcon.visible = false;
        searchBar.addChild(fieldStatusIcon);

        // progress bar here

        // error text here too?

        const requestButton = new NineSlicePlane(ENGINE.getPIXIResource("button") as Texture);
        requestButton.width = 70;
        requestButton.height = 30;
        requestButton.position.set(
            -(35) + 150,
            240
        );
        this.contentContainer.addChild(requestButton);
        const requestButtonText = new Text("Request", sharedTextStyle);
        requestButtonText.anchor.set(0.5, 0.5);
        requestButtonText.position.set(35, 15);
        requestButton.addChild(requestButtonText);
        buttonify(requestButton, {
            onFire: () => {
                if(this.blockInput) return;
                if(
                    !fieldStatusIcon.visible ||
                    fieldStatusIcon.texture !=
                        ENGINE.getPIXIResource("green-tick") as Texture
                ) {
                    //
                } else {
                    // asdf
                    this.blockInput = true;
                    _settings.onRequest(
                        this.currentType,
                        this.selectedId,
                        this.patientDropdown.currentValue
                    )
                        .catch((e) => {
                            console.error(e);
                            return null;
                        })
                        .then((e) => {
                            this.blockInput = false;
                            _settings.onClose();
                        });
                }
            }
        });

        this.position.set(
            (tsthreeConfig.width * 0.5) - 150,
            (tsthreeConfig.height * 0.5) - 155
        );
    }

    public update(
        _selectedPatientInd: number,
        _patientNames: string[],
        _doctOSWindowType: DoctOSWindowType,
    ): void {
        this.currentType = _doctOSWindowType;
        switch(this.currentType) {
            case DoctOSWindowType.Exam:
                this._title.text = "Request Examination - DoctOS";
                this.fieldText.text = "Exam: ";
                break;
            case DoctOSWindowType.Treatment:
                this._title.text = "Request Treatment - DoctOS";
                this.fieldText.text = "Treatment: ";
                break;
            case DoctOSWindowType.Diagnosis:
                this._title.text = "Make diagnosis - DoctOS";
                this.fieldText.text = "Diagnosis: ";
                break;
        }
        this.fieldStatusIcon.visible = false;
        this.searchBar.currentText = "";
        this.patientDropdown.update(_patientNames.map((e) => uppercaseFirstLettersInString(e)), _selectedPatientInd);
    }
}